import { render, staticRenderFns } from "./spin.vue?vue&type=template&id=2b937a39&scoped=true"
import script from "./spin.vue?vue&type=script&lang=js"
export * from "./spin.vue?vue&type=script&lang=js"
import style0 from "./spin.vue?vue&type=style&index=0&id=2b937a39&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b937a39",
  null
  
)

export default component.exports